// SignalR Service - DISABLED FOR NOW
// This is a stub implementation to prevent errors while SignalR is disabled

// import * as signalR from '@microsoft/signalr';

console.log('⚠️ SignalR service is currently DISABLED');

class SignalRService {
  // private connection: signalR.HubConnection | null = null;

  constructor() {
    console.log('SignalR Service initialized (DISABLED MODE)');
  }

  async connect(): Promise<void> {
    console.log('SignalR connect() called - DISABLED, skipping connection');
    return Promise.resolve();
  }

  async disconnect(): Promise<void> {
    console.log('SignalR disconnect() called - DISABLED, nothing to disconnect');
    return Promise.resolve();
  }

  on(methodName: string, callback: (...args: any[]) => void): void {
    console.log(`SignalR on('${methodName}') called - DISABLED, callback not registered`);
  }

  off(methodName: string, callback?: (...args: any[]) => void): void {
    console.log(`SignalR off('${methodName}') called - DISABLED, nothing to remove`);
  }

  async invoke(methodName: string, ...args: any[]): Promise<any> {
    console.log(`SignalR invoke('${methodName}') called - DISABLED, returning null`);
    return Promise.resolve(null);
  }

  async joinBranchGroup(branchId: string): Promise<void> {
    console.log(`SignalR joinBranchGroup('${branchId}') called - DISABLED, skipping`);
    return Promise.resolve();
  }

  async leaveBranchGroup(branchId: string): Promise<void> {
    console.log(`SignalR leaveBranchGroup('${branchId}') called - DISABLED, skipping`);
    return Promise.resolve();
  }

  isConnected(): boolean {
    return false; // Always return false when disabled
  }

  getConnectionState(): any {
    return null; // Return null when disabled
  }
}

export const signalRService = new SignalRService();
export default signalRService;